<app-top-nav />

<nav class="navbar navbar-expand-lg top-navbar">
    <div class="container">
        <!-- Logo -->
        <a class="navbar-brand" routerLink="/home" routerLinkActive="active">
            <img loading="lazy" src="images/maeen-logo.png" alt="معين للمكتبات الرقمية" class="logo-img">
        </a>

        <!-- Mobile Toggle -->
        <button class="navbar-toggler shadow-none border-0" type="button" 
            (click)="toggleMenu()"
            [attr.aria-expanded]="isMenuOpen()"
            aria-controls="navbarSupportedContent" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Navbar -->
        <div class="collapse navbar-collapse justify-content-between" [class.show]="isMenuOpen()" id="navbarSupportedContent">

            <!-- Main Menu -->
            <ul class="navbar-nav d-flex align-items-center">

                <li class="nav-item">
                    <a class="nav-link " routerLink="/home" routerLinkActive="active" (click)="isMenuOpen.set(false)">
                        {{"Nav.Home" | translate}}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLink="/browse-index" routerLinkActive="active" (click)="isMenuOpen.set(false)">
                        {{"Nav.biblios" | translate}}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLink="/advanced-search" routerLinkActive="active" (click)="isMenuOpen.set(false)">
                        {{ ("Nav.advancedSearch" | translate) || "البحث المتقدم" }}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLink="/libraries" routerLinkActive="active" (click)="isMenuOpen.set(false)">
                        {{"Nav.libraries" | translate}}
                    </a>
                </li>

                
                <li class="nav-item">
                    <a class="nav-link" href="https://portal.maeen-library.com/about-complex/help/contact-us" target="_blank" (click)="isMenuOpen.set(false)">
                        <img loading="lazy" class="icon" style="padding-inline-end:4px ;" src="images/external-link.svg"
                            alt="Maeen Library Management">

                        {{"Nav.contactUs" | translate}}
                    </a>
                </li>

            </ul>

            <!-- Actions -->
            <ol class="Actions navbar-nav d-flex align-items-center gap-1">
                <!-- Search -->
                <li class="nav-item">
                    <a class="item-action" (click)="showSearch.set(true); isMenuOpen.set(false)" routerLinkActive="active">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11 1.25C5.61522 1.25 1.25 5.61522 1.25 11C1.25 16.3848 5.61522 20.75 11 20.75C13.4224 20.75 15.6385 19.8666 17.3437 18.4043L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L18.4043 17.3437C19.8666 15.6385 20.75 13.4224 20.75 11C20.75 5.61522 16.3848 1.25 11 1.25ZM2.75 11C2.75 6.44365 6.44365 2.75 11 2.75C15.5563 2.75 19.25 6.44365 19.25 11C19.25 15.5563 15.5563 19.25 11 19.25C6.44365 19.25 2.75 15.5563 2.75 11Z"
                                fill="#161616"></path>
                        </svg>

                    </a>
                </li>

                <!-- Language -->
                <li class="nav-item" (click)="changeLanguage()">
                    <a class="item-action">
                        <img loading="lazy" src="/images/custom/lang.svg" alt="language">
                    </a>
                </li>

                <!-- User -->
                <li class="nav-item position-relative">
                    <a class="item-action" (click)="toggleAuthDropdown()" style="cursor: pointer;">
                        <!-- If user is logged in, show initial or just colored user icon, else default icon -->
                        @if (currentUser$ | async; as user) {
                           <div class="user-avatar">{{ user.firstname ? user.firstname.charAt(0) : 'U' }}</div>
                        } @else {
                           <img loading="lazy" src="images/custom/user-login.svg" alt="user" class="login-img">
                        }
                    </a>
                    
                    <!-- Auth Dropdown -->
                    @if (isAuthDropdownOpen()) {
                    <div class="auth-dropdown shadow-sm rounded">
                        @if (currentUser$ | async; as user) {
                            <div class="auth-dropdown-header">
                                <h6>{{ "Nav.welcome" | translate: { default: 'Welcome' } }}, {{ user.firstname || user.userid }}!</h6>
                                <p>{{ user.email }}</p>
                            </div>
                            <hr class="m-0">
                            <div class="auth-dropdown-body">
                                <a routerLink="/my-account" class="dropdown-link">{{ "Nav.myAccount" | translate: { default: 'My Account' } }}</a>
                                <button class="btn btn-outline-danger w-100 mt-3" (click)="logout()">{{ "Nav.logout" | translate: { default: 'Logout' } }}</button>
                            </div>
                        } @else {
                            <form (ngSubmit)="onLoginSubmit()" class="auth-dropdown-body">
                                <div class="mb-3">
                                    <label for="emailInput" class="form-label">{{ "Nav.emailAddress" | translate: { default: 'Email address' } }}</label>
                                    <input type="text" id="emailInput" class="form-control" name="email" [(ngModel)]="loginEmail" required>
                                </div>
                                <div class="mb-3">
                                    <label for="passwordInput" class="form-label">{{ "Nav.password" | translate: { default: 'Password' } }}</label>
                                    <input type="password" id="passwordInput" class="form-control" name="password" [(ngModel)]="loginPassword" required>
                                </div>
                                
                                @if (loginErrorKey) {
                                    <div class="alert alert-danger p-2 fs-7">{{ loginErrorKey | translate }}</div>
                                }
                                
                                <button type="submit" class="btn btn-primary w-100 mb-3 d-flex align-items-center justify-content-center gap-2" [disabled]="isLoading">
                                    {{ "Nav.login" | translate: { default: 'Log in' } }}
                                    @if (isLoading) {
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    } @else {
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M10 17L15 12L10 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M15 12H3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    }
                                </button>
                                
                                <div class="d-flex flex-column gap-2 text-center fs-7">
                                    <a routerLink="/register" class="text-decoration-none text-muted" (click)="isAuthDropdownOpen.set(false)">{{ "Nav.newUser" | translate: { default: 'New user? Click here to register.' } }}</a>
                                    <a routerLink="/forgot-password" class="text-decoration-none text-muted" (click)="isAuthDropdownOpen.set(false)">{{ "Nav.forgotPassword" | translate: { default: 'Have you forgotten your password?' } }}</a>
                                </div>
                            </form>
                        }
                    </div>
                    }
                </li>

            </ol>
        </div>
    </div>
</nav>

@if (showSearch()) {
<div class="search-wrapper">
    <div class="container">
        <div class="search__container position-relative">
            <div class="Button-wrapper d-flex justify-content-end">
                <button (click)="showSearch.set(false)" class="btn-close-search shadow-none p-0" type="button">
                    <img loading="lazy" src="images/custom/close-btn.svg" style="width: 12px; height: 12px"
                        alt="Close" />
                </button>
            </div>
            <div class="d-flex align-items-center justify-content-between mt-4 mt-40">
                <app-search-inp (search)="onSearch($event)"></app-search-inp>
            </div>
            <div class="suggestions mt-4">
                <!-- <h6 class="mb-3">{{ "suggestions" | translate }}</h6> -->
                <!-- <div class="d-flex flex-wrap gap-2"> -->
                <!-- <button class="btn_secondary" (click)="
                onTranslatedSearch(
                  translate.currentLang === 'en'
                    ? modelsName.quranEN
                    : modelsName.quranAR
                )
              ">
            + {{ "quran" | translate }}
          </button>
          <button class="btn_secondary" (click)="
                onTranslatedSearch(
                  translate.currentLang === 'en'
                    ? modelsName.bookEN
                    : modelsName.bookAR
                )
              ">
            + {{ "book" | translate }}
          </button>
          <button class="btn_secondary" (click)="
                onTranslatedSearch(
                  translate.currentLang === 'en'
                    ? modelsName.manuscriptEN
                    : modelsName.manuscriptAR
                )
              ">
            + {{ "menuscript" | translate }}
          </button> -->
                <!-- </div> -->
            </div>
        </div>
    </div>
</div>
}